/** Path to the report variables editor (single Skisse-based UI). */
export function reportVariablesPagePath(reportId) {
  return `/dashboard/service/reports/${reportId}/variables`;
}

/**
 * Use ReportSectionDialog + classic ReportVariables instead of the V2 variables page.
 * True when the user prefers legacy variables, or when the report still has classic field1/field2
 * rows without groups (same heuristic as grouped variables / legacy section).
 */
export function shouldOpenLegacyVariablesDialog(report, useLegacyVariablesSetting = false) {
  if (useLegacyVariablesSetting) return true;
  const vars = report?.variables;
  if (!Array.isArray(vars) || vars.length === 0) return false;

  return vars.some((variable) => {
    if (variable.delete) return false;
    const hasOldFields = !!(
      variable.field1 ||
      variable.field2 ||
      variable.field_one ||
      variable.field_two
    );
    const hasNoGroup = !variable.group_id;
    const hasNoTypeGroup = !variable.type_group_id;
    const hasNoMeasurements = !variable.measurements || variable.measurements.length === 0;
    const isNotMainVariable = !variable.is_main_variable;
    return hasOldFields && hasNoGroup && hasNoTypeGroup && hasNoMeasurements && isNotMainVariable;
  });
}

/** Report has any variable payload worth offering to copy (rows, V2 groups, or type groups). */
export function reportHasVariableDataForCopy(report) {
  if (!report) return false;
  const vars = report.variables;
  if (Array.isArray(vars) && vars.length > 0) return true;
  const groups = report.variable_groups;
  if (Array.isArray(groups) && groups.length > 0) return true;
  const typeGroups = report.variable_type_groups;
  if (Array.isArray(typeGroups) && typeGroups.length > 0) return true;
  return false;
}
